export default [
  {
    text: "Home",
    userLevel: [1, 2, 3, 19, 20],
    path: "/home",
    icon: "home"
  },
  {
    text: "Ναύλα",
    userLevel: [1, 2, 19, 20],
    icon: "event",
    items: [
        {
          text: 'Ναύλα',
          userLevel: [1, 2, 19, 20],
          path: '/ny-charter-agreement-grid',
          icon: 'spinright'
        }
    ]
  }, 
  {
    text: "Πωλήσεις",
    userLevel: [1, 2],
    icon: "product",
    items: [

    ]
  }, 
  {
    text: "Διαχείριση",
    userLevel: [1, 2, 19, 20],
    icon: "edit",
    items: [
      {
        text: 'Διαδρομές (Itineraries)',
        userLevel: [1, 2, 19, 20],
        path: '/ny-itinerary-grid',
        icon: 'spinright'
      }, 
      {
        text: 'Γεωγραφικές Τοποθεσίες',
        userLevel: [1, 2, 19, 20],
        path: '/ny-geo-locations-grid',
        icon: 'spinright'
      }
    
    ]
  }, 
  {
    text: "Οικονομικά",
    icon: "money",
    userLevel: [1, 2],
    items: [

    ]
  }, 
  {
    text: "Στατιστικά",
    icon: "chart",
    userLevel: [1, 2],
    items: [

    ]
  }, 
  {
    text: "Σύστημα",
    icon: "preferences",
    userLevel: [1, 2],
    items: [

    ]
  }, 
  {
    text: "Χρήστες",
    icon: "group",
    userLevel: [1, 2],
    items: [
        {
          text: 'Χρήστες',
          userLevel: [1, 2],
          path: '/ny-system-users-grid',
          icon: 'spinright'
        },
        {
          text: 'Προφίλ Χρήστη',
          userLevel: [1, 2],
          path: '/ny-system-users-profile-form',
          icon: 'spinright'
        }
      ]
  },
  ];

  /*
  if LoggedNYUser.IsOffice then
  begin
    MenuNodesACL.Add('TFormYachtExtrasInventory');
    MenuNodesACL.Add('TFormProviderExtras');
    MenuNodesACL.Add('TFormEmailProposalPublished');
    MenuNodesACL.Add('TFormYachtsCharterPlans');
    MenuNodesACL.Add('TNYFormYachts');
    MenuNodesACL.Add('TNYFormYachtsModels');
    MenuNodesACL.Add('TFormCharterParties');
    MenuNodesACL.Add('TNYFormReportYachtHealthCheck');
  end;

  if LoggedNYUser.IsSales then
  begin
    //MenuNodesACL.Add('TFormYachtExtrasInventory');
    //MenuNodesACL.Add('TFormProviderExtras');
    MenuNodesACL.Add('TFormEmailProposalPublished');
    //MenuNodesACL.Add('TFormYachtsCharterPlans');
    MenuNodesACL.Add('TNYFormYachts');
    MenuNodesACL.Add('TNYFormYachtsModels');
    MenuNodesACL.Add('TFormCharterParties');
    MenuNodesACL.Add('TNYFormReportYachtHealthCheck');
    MenuNodesACL.Add('TFormRequestsMain');
  end;
  */